import {
  mixinDialogMutations,
  mixinDialogActions,
  mixinDialogGetters
} from '@/mixins/vuexDialogs'

import { getField, updateField } from 'vuex-map-fields'

export default {
  namespaced: true,
  state: {
    loading: {
      mainTable: false
    },
    pagination: {},
    links: {
      linkForDeleting: '',
      createdLinksListPagination: {},
      createdLinksList: []
    },
    linksForStatisticsFilter: {
      items: [],
      pagination: {}
    },
    statistics: {
      data: [],
      pagination: {},
      balance: '',
      users: '',
      filters: {
        selectedSubAccounts: [],
        statisticsDate: {
          value: 'forAllTheTime',
          dateFrom: '',
          dateTo: ''
        }
      }
    },
    payments: {
      data: [],
      pagination: {},
      filters: {
        paymentsDate: {
          value: 'forAllTheTime',
          dateFrom: '',
          dateTo: ''
        }
      }
    }
  },

  getters: {
    ...mixinDialogGetters,
    getField,
    
    statistics: state => state.statistics,
    statisticsData: state => state.statistics.data,
    statisticsPagination: state => state.statistics.pagination,
    statisticsFilters: state => state.statistics.filters,
    statisticsBalance: state => state.statistics.balance,
    statisticsUsers: state => state.statistics.users,
    paymentsData: state => state.payments.data,
    paymentsPagination: state => state.payments.pagination,
    paymentsFilters: state => state.payments.filters,
    linkForDeleting: state => state.links.linkForDeleting,
    createdLinksListPagination: state => state.links.createdLinksListPagination,
    createdLinksList: state => state.links.createdLinksList,
    linksForStatisticsFilterItems: state => state.linksForStatisticsFilter.items,
    linksPaginationForStatisticsFilter: state => state.linksForStatisticsFilter.pagination
  },
  
  mutations: {
    ...mixinDialogMutations,
    updateField,

    SET_LINK_FOR_DELETING: (state, payload) => {
      state.links.linkForDeleting = payload
    },
    SET_CREATED_LINKS_LIST: (state, payload) => {
      state.links.createdLinksList = payload
    },
    SET_CREATED_LINKS_LIST_PAGINATION: (state, payload) => {
      state.links.createdLinksListPagination = payload
    },
    SET_LINKS_FOR_STATISTICS_FILTER: (state, payload) => {
      state.linksForStatisticsFilter.items.push(...payload)
    },
    SET_STATISTICS_FILTER_LINKS_PAGINATION: (state, payload) => {
      state.linksForStatisticsFilter.pagination = payload
    },
    SET_STATISTICS_FILTERS: (state, { key, value }) => {
      state.statistics.filters[key] = value
    },
    SET_STATISTICS_DATA: (state, payload) => {
      state.statistics.data = payload
    },
    SET_STATISTICS_BALANCE: (state, payload) => {
      state.statistics.balance = payload
    },
    SET_STATISTICS_USERS: (state, payload) => {
      state.statistics.users = payload
    },
    SET_STATISTICS_PAGINATION: (state, payload) => {
      state.statistics.pagination = payload
    },
    SET_PAYMENTS_FILTERS: (state, { key, value }) => {
      state.payments.filters[key] = value
    },
    SET_PAYMENTS_DATA: (state, payload) => {
      state.payments.data = payload
    },
    SET_PAYMENTS_PAGINATION: (state, payload) => {
      state.payments.pagination = payload
    },
  },

  actions: {
    ...mixinDialogActions,
    setLinkForDeleting (context, data) {
      context.commit('SET_LINK_FOR_DELETING', data)
    },
    async getCreatingLinks({ commit }, pageNumber) {
      const page = pageNumber || 1
      const url = `/profile/referral-links?limit=9&page=${page}`

      try {
        const response = await this._vm.api.get(url)
        const data = response.data

        commit('SET_CREATED_LINKS_LIST', data.data)
        commit('SET_CREATED_LINKS_LIST_PAGINATION', {
          currentPage: parseInt(data.current_page, 10),
          lastPage: parseInt(data.last_page, 10),
          perPage: parseInt(data.per_page, 10)
        })
      } catch (err) {
        console.error(err)
      }
    },
    async loadLinksForStatisticsFilter({ state, commit }) {
      try {
        const currentPage = state.linksForStatisticsFilter.pagination.currentPage
        const page = currentPage ? currentPage + 1 : 1
        const url = `/profile/referral-links?limit=50&page=${page}`

        const response = await this._vm.api.get(url)
        const data = response.data

        commit('SET_LINKS_FOR_STATISTICS_FILTER', data.data)
        commit('SET_STATISTICS_FILTER_LINKS_PAGINATION', {
          currentPage: parseInt(data.current_page, 10),
          lastPage: parseInt(data.last_page, 10),
          totalItemsCount: parseInt(data.total, 10),
        })
      } catch (err) {
        console.error(err)
      }
    },
    setStatisticsFilters (context, data) {
      context.commit('SET_STATISTICS_FILTERS', data)
    },
    async loadStatistics (context, pageNumber) {
      const page = pageNumber || 1;

      let url = `/profile/referral-links/statistics?limit=10&page=${page}`;

      const filters = context.state.statistics.filters;
      const allAffiliateLinksCount = context.state.linksForStatisticsFilter.items.length + 1

      const params = {}

      if (filters.selectedSubAccounts.length < allAffiliateLinksCount) {
        params.sources = [...new Set(filters.selectedSubAccounts.map(i => i.isMainLink ? 'MAIN-LINK#' : i.source))]
      }

      if (filters.statisticsDate.dateTo) {
        params.end_date = filters.statisticsDate.dateTo
      }

      if (filters.statisticsDate.dateFrom) {
        params.start_date = filters.statisticsDate.dateFrom
      }

      try {
        const res = await this._vm.api.get(url, { params })
        const data = res.data.data

        context.commit('SET_STATISTICS_DATA', data.data)
        context.commit('SET_STATISTICS_BALANCE', res.data.balance)
        context.commit('SET_STATISTICS_USERS', res.data.users_count)
        context.commit('SET_STATISTICS_PAGINATION', {
          currentPage: parseInt(data.current_page, 10),
          lastPage: parseInt(data.last_page, 10),
          perPage: parseInt(data.per_page, 10)
        })
      } catch (err) {
        console.error(err)
      }
    },
    setPaymentsFilters (context, data) {
      context.commit('SET_PAYMENTS_FILTERS', data)
    },
    async loadPayments (context, pageNumber) {
      const page = pageNumber || 1
      const url = `/profile/referral-links/payments?limit=10&page=${page}`
      const filters = context.state.payments.filters
      const params = {}

      if (filters.paymentsDate.dateTo) {
        params.end_date = filters.paymentsDate.dateTo
      }

      if (filters.paymentsDate.dateFrom) {
        params.start_date = filters.paymentsDate.dateFrom
      }

      try {
        const res = await this._vm.api.get(url, { params });
        const data = res.data;

        context.commit('SET_PAYMENTS_DATA', data.data)
        context.commit('SET_PAYMENTS_PAGINATION', {
          currentPage: parseInt(data.current_page, 10),
          lastPage: parseInt(data.last_page, 10),
          perPage: parseInt(data.per_page, 10)
        })
      } catch (err) {
        console.error(err)
      }
    }
  }
}

